import { useId } from "react";

export type SwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  showLabel?: boolean;
  disabled?: boolean;
  className?: string;
  name?: string;
};

export function Switch({ checked, onChange, label, showLabel = false, disabled = false, className, name }: SwitchProps) {
  const id = useId();

  return (
    <label className={["fxmap-switch", showLabel ? "fxmap-switch-labelled" : "", className ?? ""].filter(Boolean).join(" ")} htmlFor={id}>
      {showLabel ? <span className="fxmap-switch-text">{label}</span> : null}
      <span className="fxmap-switch-control">
        <input id={id} name={name} type="checkbox" role="switch" aria-label={showLabel ? undefined : label} aria-checked={checked} checked={checked} disabled={disabled} onChange={event => onChange(event.target.checked)} />
        <span className="fxmap-switch-track" aria-hidden="true" />
      </span>
    </label>
  );
}
